import { getUserInfo } from '@/domain/account/api';
import { useQuery } from '@tanstack/react-query';

export const useUserInfo = (enabled = true) =>
  useQuery({
    queryKey: ['user'],
    // Wrapped rather than passed by reference: react-query calls queryFn with its own context object,
    // which would arrive as the bearer argument.
    queryFn: () => getUserInfo(),
    staleTime: 1000 * 60 * 15,
    enabled,
  });
